<template>
  <v-pagination
    v-model="page"
    :pages="setMaxPage()"
    :range-size="1"
    active-color="#DEE0E2"
    @update:modelValue="setPageSearch()"
  />
</template>

<script>
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";

export default {
    name: "PageCount",
    data (){
        return {
            page: this.$store.state.pageNumber,
        }
    },
    components: {
        VPagination
    },
    computed: {
        pageNumber() {
            return this.$store.state.pageNumber; // Get the store value
        }
    },
    watch: {
        pageNumber(newVal) {
            this.page = newVal; // Update page when store value changes
        }
    },
    methods: {
        setMaxPage () {
            let maxPage = Math.ceil(this.$store.state.resultCount / this.$root.recordsPerPage)
            return maxPage
        },
        setPageSearch() {
            this.$store.commit('setPageNumber', this.page)
            this.$store.dispatch('search', {})
        },
    }
}
</script>
<style lang="scss"  scoped src="@/assets/css/PageCount.scss"></style>